import React, {useEffect, useState } from 'react';
import './Trends.css';
import Navbar from "../Navbar/Nabvar";
import Footer from '../Footer/Footer';
import {
    Box,
    Typography,
    Container,
    Card,
    CardContent,
    CardMedia,
    Button,
    styled,
    useTheme
} from '@mui/material';
import mock_trends from './mock_trends';
import { useNavigate } from 'react-router-dom';
import QuoteBox from '../Quote/QuoteBox';

// @ts-ignore
const MegatrendCard = ({ trend }) => {
    const navigate = useNavigate();
    const theme = useTheme(); // Theme-Hook hinzufügen

    return (
        <Card
            sx={{
                position: 'relative',
                border: `2px solid ${trend.color}`,
                borderRadius: '8px',
                overflow: 'hidden',
                cursor: 'pointer',
                height: {
                    xs: '200px', // Kleinere Höhe auf mobilen Geräten
                    sm: '220px',
                    md: '250px' // Original-Höhe auf größeren Bildschirmen
                }
            }}
            onClick={() => navigate(`/megatrend/${trend.id}`)}
        >
            <CardMedia
                component="img"
                sx={{
                    height: '100%', // Anpassung der Bildhöhe
                    objectFit: 'cover'
                }}
                image={trend.image || "/api/placeholder/400/320"}
                alt={trend.title}
            />
            <CardContent sx={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                background: trend.color,
                padding: {
                    xs: '8px !important', // Kleineres Padding auf mobilen Geräten
                    sm: '12px !important',
                    md: '16px !important' // Original-Padding auf größeren Bildschirmen
                },
            }}>
                <Typography variant="h5" sx={{
                    color: 'white',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginLeft: "-10%",
                    fontSize: {
                        xs: '1rem', // Kleinere Schrift auf mobilen Geräten
                        sm: '1.2rem',
                        md: '1.5rem' // Original-Schriftgröße auf größeren Bildschirmen
                    }
                }}>
                    {trend.title}
                </Typography>
            </CardContent>
        </Card>
    );
};

const MainContent = styled(Box)({
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
            linear-gradient(to bottom right, 
                rgba(240, 245, 255, 0.9),
                rgba(230, 240, 255, 0.9)
            )
        `,
        zIndex: 0
    }
});

const ContentWrapper = styled(Box)({
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: '0',
    padding: '0',
});

const ContentSection = styled(Box)(({ theme }) => ({
    width: '100%',
    margin: '150px 0',
    padding: theme.spacing(4),
    backgroundColor: '#fff',
    borderTop: '0.5px solid #2514b8',
    borderBottom: '0.5px solid #2514b8',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
        margin: '100px 0',
        padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
        margin: '50px 0',
        padding: theme.spacing(2),
    },
}));

// Weitere styled components bleiben gleich...
const ImageContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
    margin: theme.spacing(4, 0),
    width: '100%', // Hinzugefügt
    '& img': {
        width: '100%', // Geändert
        maxWidth: '900px', // Angepasst
        height: 'auto',
        [theme.breakpoints.down('md')]: {
            maxWidth: '100%',
        },
    },
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
    },
}));

const CardGrid = styled(Box)(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)', // 4 Spalten
    gap: theme.spacing(2),
    width: '65%',
    padding: theme.spacing(2),
    '& .MuiCard-root': {
        width: '100%',
        backgroundColor: '#186cff',
        margin: theme.spacing(1),
    },
    [theme.breakpoints.down('lg')]: { // Neue Breakpoint für große Bildschirme
        width: '80%',
        gridTemplateColumns: 'repeat(3, 1fr)', // 3 Spalten auf großen Bildschirmen
    },
    [theme.breakpoints.down('md')]: {
        width: '90%',
        gridTemplateColumns: 'repeat(2, 1fr)', // 2 Spalten auf mittleren Bildschirmen
    },
    [theme.breakpoints.down('sm')]: {
        width: '95%',
        gridTemplateColumns: '1fr', // 1 Spalte auf kleinen Bildschirmen
        '& .MuiCard-root': {
            width: '100%',
            margin: theme.spacing(2, 0),
        },
    },
}));

const Trends = () => {
    const primaryBlue = '#1F1B9E';
    const [trendkorb, setTrendkorb] = useState<string[]>([]);
    const [trendkorbCount, setTrendkorbCount] = useState(0);
    const navigate = useNavigate();
    const trends = mock_trends;

    const addToTrendkorb = (trendName: string) => {
        setTrendkorb((prevTrendkorb) => {
            const updatedTrendkorb = [...prevTrendkorb, trendName];
            setTrendkorbCount(updatedTrendkorb.length);
            return updatedTrendkorb;
        });
    };

    const removeFromTrendkorb = (trendName: string) => {
        setTrendkorb((prevTrendkorb) => {
            const updatedTrendkorb = prevTrendkorb.filter(item => item !== trendName);
            setTrendkorbCount(updatedTrendkorb.length);
            return updatedTrendkorb;
        });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Navbar />
            <MainContent>
                <ContentWrapper>
                    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <img
                            src="old/search-removebg-preview.png"
                            alt="Logo"
                            style={{
                                height: "auto",
                                width: '80%',
                                maxWidth: '400px',
                                margin: '0 auto',
                                paddingTop: '80px',
                            }}
                        />

                        <Typography
                            variant="body1"
                            sx={{
                                color: primaryBlue,
                                maxWidth: '1300px',
                                mx: 'auto',
                                px: 2,
                                fontSize: '1.6rem',
                                mb: 3,
                                textAlign: 'center',
                                marginBottom: '-100px',
                            }}
                        >
                            Erkennen Sie heute die Chancen von morgen! Entdecken Sie die 12 Megatrends, die die Zukunft der Wirtschaft prägen, und die wichtigsten Geschäftsmodelltrends, die daraus entstehen. Nutzen Sie diese Erkenntnisse, um Ihr Business strategisch auszurichten und neue Potenziale zu erschließen!
                        </Typography>

                    </Box>

                    {/* Hiking image section */}
                    {/*<Box*/}
                    {/*    sx={{*/}
                    {/*        width: '100%',*/}
                    {/*        position: 'relative',*/}
                    {/*        my: 4, // Add margin top and bottom*/}
                    {/*        '&::before': {*/}
                    {/*            content: '""',*/}
                    {/*            position: 'absolute',*/}
                    {/*            top: 0,*/}
                    {/*            left: 0,*/}
                    {/*            right: 0,*/}
                    {/*            height: '1px',*/}
                    {/*            backgroundColor: primaryBlue,*/}
                    {/*        },*/}
                    {/*        '&::after': {*/}
                    {/*            content: '""',*/}
                    {/*            position: 'absolute',*/}
                    {/*            bottom: 0,*/}
                    {/*            left: 0,*/}
                    {/*            right: 0,*/}
                    {/*            height: '1px',*/}
                    {/*            backgroundColor: primaryBlue,*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <Box*/}
                    {/*        sx={{*/}
                    {/*            width: '100%',*/}
                    {/*            height: { xs: '400px', sm: '600px', md: '800px' },*/}
                    {/*            backgroundImage: 'url("/old/wandern_kontakt.png")',*/}
                    {/*            backgroundSize: 'cover',*/}
                    {/*            backgroundPosition: 'center',*/}
                    {/*        }}*/}
                    {/*    />*/}
                    {/*</Box>*/}


                    <ContentSection>
                        <Typography
                            variant="h1"
                            sx={{
                                color: primaryBlue,
                                mb: 4,
                                fontSize: {
                                    xs: '2rem',  // Mobile
                                    sm: '2.5rem', // Tablet
                                    md: '3rem',   // Desktop klein
                                    lg: '3.5rem'  // Desktop groß
                                },
                                fontWeight: 'bold',
                                textAlign: 'center'
                            }}
                        >
                            Megatrends
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: primaryBlue,
                                maxWidth: '1150px',
                                mx: 'auto',
                                px: 2,
                                fontSize: {
                                    xs: '1rem',  // Mobile
                                    sm: '1.2rem', // Tablet
                                    md: '1.5rem'  // Desktop
                                },
                                mb: 3,
                                textAlign: 'center'
                            }}
                        >
                            Klicken Sie auf die Kacheln um, zu den Geschäftsmodell-Subtrends zu gelangen.
                        </Typography>

                        <CardGrid
                            sx={{
                                gap: 10, // Abstand zwischen den Kacheln
                            }}
                        >
                            {trends.map((trend) => (
                                <MegatrendCard key={trend.id} trend={trend} />
                            ))}
                        </CardGrid>

                        <Typography
                            variant="body1"
                            sx={{
                                color: primaryBlue,
                                maxWidth: '1150px',
                                mx: 'auto',
                                px: 2,
                                fontSize: '1rem',
                                mb: 3,
                                textAlign: 'center',
                                marginTop: "40px",
                                marginBottom: "-10px"
                            }}
                        >
                            Quelle: 12 Megatrends des Zukunftsinstituts
                        </Typography>

                    </ContentSection>

                    {/*Was sind trends*/}
                    <ContentSection sx={{marginTop:"-10px"}}>

                        <Typography
                            variant="h1"
                            sx={{
                                color: primaryBlue,
                                mb: 4,
                                fontSize: '3.5rem',
                                fontWeight: 'bold'
                            }}
                        >
                            Was sind Trends?
                        </Typography>


                        <Typography
                            variant="body1"
                            sx={{
                                color: primaryBlue,
                                maxWidth: '1600px',
                                mx: 'auto',
                                px: 2,
                                fontSize: '1.5rem',
                                mb: 3, // Abstand nach unten,
                                textAlign: 'center'
                            }}
                        >
                            Ein Trend ist eine langfristige Entwicklung, die Wirtschaft, Gesellschaft und Technologie nachhaltig verändert. Trends entstehen durch neue Bedürfnisse, technologische Innovationen oder gesellschaftliche Umbrüche und zeigen, in welche Richtung sich Märkte und Geschäftsmodelle bewegen. Wer Trends frühzeitig erkennt, kann Wettbewerbsvorteile sichern und innovative Geschäftsstrategien entwickeln.
                        </Typography>

                        <Box
                            component="img"
                            src="old/diagramm.jpg"
                            sx={{
                                width: "70%",
                                marginTop: 1,
                                marginBottom: 7,
                                border: '2px solid #1F1B9E' // Blauer Rand
                            }}
                        />


                        {/***********************************************/}

                    </ContentSection>

                    <ContentSection sx={{marginTop:"-10px"}}>
                        <Typography
                            variant="h1"
                            sx={{
                                color: primaryBlue,
                                mb: 4,
                                fontSize: '3.5rem',
                                fontWeight: 'bold'
                            }}
                        >
                            Trendmaps
                        </Typography>

                        <Typography
                            variant="body1"
                            sx={{
                                color: primaryBlue,
                                maxWidth: '1600px',
                                mx: 'auto',
                                px: 2,
                                fontSize: '1.5rem',
                                mb: 3, // Abstand nach unten,
                                textAlign: 'center',
                                backgroundColor: 'white' // Hintergrundfarbe auf Weiß setzen
                            }}
                        >
                            Auswahl an aktuellen Trend-Sammlungen
                        </Typography>

                        <CardGrid gap={10}>
                            <Card sx={{ border: '2px solid black' }}>
                                <CardMedia
                                    component="img"
                                    height="250"
                                    image="old/trendOne.png"
                                    alt="Technologie-basierte Geschäftsmodell-Trends"
                                />
                                <CardContent sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Typography sx={{
                                        color: 'black',
                                        mb: 2,
                                        fontSize: '1.3rem',
                                        fontWeight: 'bold'
                                    }}>
                                        Trend One
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            mt: 2,
                                            color: primaryBlue,
                                            borderColor: primaryBlue,
                                            borderRadius: '24px',
                                            padding: '8px 32px',
                                            fontSize: '1.1rem',
                                            width: '200px',
                                            backgroundColor: 'white', // Hintergrundfarbe auf Weiß setzen
                                            '&:hover': {
                                                borderColor: primaryBlue,
                                                backgroundColor: 'rgba(31, 27, 158, 0.04)'
                                            }
                                        }}
                                        onClick={() => window.open("https://blog.trendone.com/megatrend-map/", "_blank")}
                                    >
                                        Öffnen
                                    </Button>
                                </CardContent>
                            </Card>

                            <Card sx={{ border: '2px solid black' }}>
                                <CardMedia
                                    component="img"
                                    height="250"
                                    image="old/trendTwo.png"
                                    alt="Ökologische Geschäftsmodell-Trends"
                                />
                                <CardContent sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Typography sx={{
                                        color: 'black',
                                        mb: 2,
                                        fontSize: '1.3rem',
                                        fontWeight: 'bold'
                                    }}>
                                        Trendhunter
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            mt: 2,
                                            color: primaryBlue,
                                            borderColor: primaryBlue,
                                            borderRadius: '24px',
                                            padding: '8px 32px',
                                            fontSize: '1.1rem',
                                            width: '200px',
                                            backgroundColor: 'white', // Hintergrundfarbe auf Weiß setzen
                                            '&:hover': {
                                                borderColor: primaryBlue,
                                                backgroundColor: 'rgba(31, 27, 158, 0.04)'
                                            }
                                        }}
                                        onClick={() => window.open("https://www.trendhunter.com/megatrends", "_blank")}
                                    >
                                        Öffnen
                                    </Button>
                                </CardContent>
                            </Card>

                            <Card sx={{ border: '2px solid black' }}>
                                <CardMedia
                                    component="img"
                                    height="250"
                                    image="old/trendThree.png"
                                    alt="Gesundheits-basierte Geschäftsmodell-Trends"
                                />
                                <CardContent sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Typography sx={{
                                        color: 'black',
                                        mb: 2,
                                        fontSize: '1.3rem',
                                        fontWeight: 'bold'
                                    }}>
                                        Zukunftsinstitut
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            mt: 2,
                                            color: primaryBlue,
                                            borderColor: primaryBlue,
                                            borderRadius: '24px',
                                            padding: '8px 32px',
                                            fontSize: '1.1rem',
                                            width: '200px',
                                            backgroundColor: 'white', // Hintergrundfarbe auf Weiß setzen
                                            '&:hover': {
                                                borderColor: primaryBlue,
                                                backgroundColor: 'rgba(31, 27, 158, 0.04)'
                                            }
                                        }}
                                        onClick={() => window.open("https://www.zukunftsinstitut.de/megatrends#widget_1706627447288", "_blank")}
                                    >
                                        Öffnen
                                    </Button>
                                </CardContent>
                            </Card>

                            <Card sx={{ border: '2px solid black' }}>
                                <CardMedia
                                    component="img"
                                    height="250"
                                    image="old/trendFour.png"
                                    alt="Faktor Mensch in modernen Geschäftsmodellen"
                                />
                                <CardContent sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                    <Typography sx={{
                                        color: 'black',
                                        mb: 2,
                                        fontSize: '1.3rem',
                                        fontWeight: 'bold'
                                    }}>
                                        Zukunft Handwerk
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            mt: 2,
                                            color: primaryBlue,
                                            borderColor: primaryBlue,
                                            borderRadius: '24px',
                                            padding: '8px 32px',
                                            fontSize: '1.1rem',
                                            width: '200px',
                                            backgroundColor: 'white', // Hintergrundfarbe auf Weiß setzen
                                            '&:hover': {
                                                borderColor: primaryBlue,
                                                backgroundColor: 'rgba(31, 27, 158, 0.04)'
                                            }
                                        }}
                                        onClick={() => window.open("https://www.zukunfthandwerk.com/trends/trendradar/", "_blank")}
                                    >
                                        Öffnen
                                    </Button>
                                </CardContent>
                            </Card>
                        </CardGrid>
                    </ContentSection>

                    <Box sx={{marginTop:"-200px", marginBottom:"-80px"}}>
                        <QuoteBox
                            text="„Die Zukunft kann man am besten voraussagen, wenn man sie selbst gestaltet.“"
                            maxWidth="1200px"
                            author={"Alan Kay"}
                        />

                    </Box>


                </ContentWrapper>
            </MainContent>
            <Footer />
        </>
    );
};

export default Trends;